/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BrowseRouteImport } from './routes/browse'
import { Route as MeRouteImport } from './routes/me'
import { Route as PolicyRouteImport } from './routes/policy'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as CreateIndexRouteImport } from './routes/create.index'
import { Route as CreateImportRouteImport } from './routes/create.import'
import { Route as GuestVerifyRouteImport } from './routes/guest.verify'
import { Route as OauthConsentRouteImport } from './routes/oauth.consent'
import { Route as PlaygroundIndexRouteImport } from './routes/playground.index'
import { Route as PlaygroundDiffRouteImport } from './routes/playground.diff'
import { Route as CNsIndexRouteImport } from './routes/c.$ns.index'
import { Route as CNsNameRouteImport } from './routes/c.$ns.$name'
import { Route as CNsNameIndexRouteImport } from './routes/c.$ns.$name.index'
import { Route as CNsNamePreviewRouteImport } from './routes/c.$ns.$name.preview'
import { Route as CNsNameSettingsRouteImport } from './routes/c.$ns.$name.settings'
import { Route as CNsNameVersionsRouteImport } from './routes/c.$ns.$name.versions'
import { Route as CNsNameDiffRouteImport } from './routes/c.$ns.$name_.diff'
import { Route as CNsNameEditRouteImport } from './routes/c.$ns.$name_.edit'
import { Route as CNsNameContributionsIndexRouteImport } from './routes/c.$ns.$name.contributions.index'
import { Route as CNsNameContributionsNumberRouteImport } from './routes/c.$ns.$name.contributions.$number'
import { Route as CNsNameContributionsNewRouteImport } from './routes/c.$ns.$name.contributions.new'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BrowseRoute = BrowseRouteImport.update({
  id: '/browse',
  path: '/browse',
  getParentRoute: () => rootRouteImport,
} as any)
const MeRoute = MeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => rootRouteImport,
} as any)
const PolicyRoute = PolicyRouteImport.update({
  id: '/policy',
  path: '/policy',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateIndexRoute = CreateIndexRouteImport.update({
  id: '/create/',
  path: '/create/',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateImportRoute = CreateImportRouteImport.update({
  id: '/create/import',
  path: '/create/import',
  getParentRoute: () => rootRouteImport,
} as any)
const GuestVerifyRoute = GuestVerifyRouteImport.update({
  id: '/guest/verify',
  path: '/guest/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const PlaygroundIndexRoute = PlaygroundIndexRouteImport.update({
  id: '/playground/',
  path: '/playground/',
  getParentRoute: () => rootRouteImport,
} as any)
const PlaygroundDiffRoute = PlaygroundDiffRouteImport.update({
  id: '/playground/diff',
  path: '/playground/diff',
  getParentRoute: () => rootRouteImport,
} as any)
const CNsIndexRoute = CNsIndexRouteImport.update({
  id: '/c/$ns/',
  path: '/c/$ns/',
  getParentRoute: () => rootRouteImport,
} as any)
const CNsNameRoute = CNsNameRouteImport.update({
  id: '/c/$ns/$name',
  path: '/c/$ns/$name',
  getParentRoute: () => rootRouteImport,
} as any)
const CNsNameIndexRoute = CNsNameIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CNsNameRoute,
} as any)
const CNsNamePreviewRoute = CNsNamePreviewRouteImport.update({
  id: '/preview',
  path: '/preview',
  getParentRoute: () => CNsNameRoute,
} as any)
const CNsNameSettingsRoute = CNsNameSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => CNsNameRoute,
} as any)
const CNsNameVersionsRoute = CNsNameVersionsRouteImport.update({
  id: '/versions',
  path: '/versions',
  getParentRoute: () => CNsNameRoute,
} as any)
const CNsNameDiffRoute = CNsNameDiffRouteImport.update({
  id: '/c/$ns/$name_/diff',
  path: '/c/$ns/$name/diff',
  getParentRoute: () => rootRouteImport,
} as any)
const CNsNameEditRoute = CNsNameEditRouteImport.update({
  id: '/c/$ns/$name_/edit',
  path: '/c/$ns/$name/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const CNsNameContributionsIndexRoute =
  CNsNameContributionsIndexRouteImport.update({
    id: '/contributions/',
    path: '/contributions/',
    getParentRoute: () => CNsNameRoute,
  } as any)
const CNsNameContributionsNumberRoute =
  CNsNameContributionsNumberRouteImport.update({
    id: '/contributions/$number',
    path: '/contributions/$number',
    getParentRoute: () => CNsNameRoute,
  } as any)
const CNsNameContributionsNewRoute = CNsNameContributionsNewRouteImport.update({
  id: '/contributions/new',
  path: '/contributions/new',
  getParentRoute: () => CNsNameRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/browse': typeof BrowseRoute
  '/me': typeof MeRoute
  '/policy': typeof PolicyRoute
  '/settings': typeof SettingsRoute
  '/create/import': typeof CreateImportRoute
  '/guest/verify': typeof GuestVerifyRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/playground/diff': typeof PlaygroundDiffRoute
  '/create/': typeof CreateIndexRoute
  '/playground/': typeof PlaygroundIndexRoute
  '/c/$ns/$name': typeof CNsNameRouteWithChildren
  '/c/$ns/': typeof CNsIndexRoute
  '/c/$ns/$name/preview': typeof CNsNamePreviewRoute
  '/c/$ns/$name/settings': typeof CNsNameSettingsRoute
  '/c/$ns/$name/versions': typeof CNsNameVersionsRoute
  '/c/$ns/$name/diff': typeof CNsNameDiffRoute
  '/c/$ns/$name/edit': typeof CNsNameEditRoute
  '/c/$ns/$name/': typeof CNsNameIndexRoute
  '/c/$ns/$name/contributions/$number': typeof CNsNameContributionsNumberRoute
  '/c/$ns/$name/contributions/new': typeof CNsNameContributionsNewRoute
  '/c/$ns/$name/contributions/': typeof CNsNameContributionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/browse': typeof BrowseRoute
  '/me': typeof MeRoute
  '/policy': typeof PolicyRoute
  '/settings': typeof SettingsRoute
  '/create/import': typeof CreateImportRoute
  '/guest/verify': typeof GuestVerifyRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/playground/diff': typeof PlaygroundDiffRoute
  '/create': typeof CreateIndexRoute
  '/playground': typeof PlaygroundIndexRoute
  '/c/$ns': typeof CNsIndexRoute
  '/c/$ns/$name/preview': typeof CNsNamePreviewRoute
  '/c/$ns/$name/settings': typeof CNsNameSettingsRoute
  '/c/$ns/$name/versions': typeof CNsNameVersionsRoute
  '/c/$ns/$name/diff': typeof CNsNameDiffRoute
  '/c/$ns/$name/edit': typeof CNsNameEditRoute
  '/c/$ns/$name': typeof CNsNameIndexRoute
  '/c/$ns/$name/contributions/$number': typeof CNsNameContributionsNumberRoute
  '/c/$ns/$name/contributions/new': typeof CNsNameContributionsNewRoute
  '/c/$ns/$name/contributions': typeof CNsNameContributionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/browse': typeof BrowseRoute
  '/me': typeof MeRoute
  '/policy': typeof PolicyRoute
  '/settings': typeof SettingsRoute
  '/create/import': typeof CreateImportRoute
  '/guest/verify': typeof GuestVerifyRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/playground/diff': typeof PlaygroundDiffRoute
  '/create/': typeof CreateIndexRoute
  '/playground/': typeof PlaygroundIndexRoute
  '/c/$ns/$name': typeof CNsNameRouteWithChildren
  '/c/$ns/': typeof CNsIndexRoute
  '/c/$ns/$name/preview': typeof CNsNamePreviewRoute
  '/c/$ns/$name/settings': typeof CNsNameSettingsRoute
  '/c/$ns/$name/versions': typeof CNsNameVersionsRoute
  '/c/$ns/$name_/diff': typeof CNsNameDiffRoute
  '/c/$ns/$name_/edit': typeof CNsNameEditRoute
  '/c/$ns/$name/': typeof CNsNameIndexRoute
  '/c/$ns/$name/contributions/$number': typeof CNsNameContributionsNumberRoute
  '/c/$ns/$name/contributions/new': typeof CNsNameContributionsNewRoute
  '/c/$ns/$name/contributions/': typeof CNsNameContributionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/browse'
    | '/me'
    | '/policy'
    | '/settings'
    | '/create/import'
    | '/guest/verify'
    | '/oauth/consent'
    | '/playground/diff'
    | '/create/'
    | '/playground/'
    | '/c/$ns/$name'
    | '/c/$ns/'
    | '/c/$ns/$name/preview'
    | '/c/$ns/$name/settings'
    | '/c/$ns/$name/versions'
    | '/c/$ns/$name/diff'
    | '/c/$ns/$name/edit'
    | '/c/$ns/$name/'
    | '/c/$ns/$name/contributions/$number'
    | '/c/$ns/$name/contributions/new'
    | '/c/$ns/$name/contributions/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/browse'
    | '/me'
    | '/policy'
    | '/settings'
    | '/create/import'
    | '/guest/verify'
    | '/oauth/consent'
    | '/playground/diff'
    | '/create'
    | '/playground'
    | '/c/$ns'
    | '/c/$ns/$name/preview'
    | '/c/$ns/$name/settings'
    | '/c/$ns/$name/versions'
    | '/c/$ns/$name/diff'
    | '/c/$ns/$name/edit'
    | '/c/$ns/$name'
    | '/c/$ns/$name/contributions/$number'
    | '/c/$ns/$name/contributions/new'
    | '/c/$ns/$name/contributions'
  id:
    | '__root__'
    | '/'
    | '/browse'
    | '/me'
    | '/policy'
    | '/settings'
    | '/create/import'
    | '/guest/verify'
    | '/oauth/consent'
    | '/playground/diff'
    | '/create/'
    | '/playground/'
    | '/c/$ns/$name'
    | '/c/$ns/'
    | '/c/$ns/$name/preview'
    | '/c/$ns/$name/settings'
    | '/c/$ns/$name/versions'
    | '/c/$ns/$name_/diff'
    | '/c/$ns/$name_/edit'
    | '/c/$ns/$name/'
    | '/c/$ns/$name/contributions/$number'
    | '/c/$ns/$name/contributions/new'
    | '/c/$ns/$name/contributions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BrowseRoute: typeof BrowseRoute
  MeRoute: typeof MeRoute
  PolicyRoute: typeof PolicyRoute
  SettingsRoute: typeof SettingsRoute
  CreateImportRoute: typeof CreateImportRoute
  GuestVerifyRoute: typeof GuestVerifyRoute
  OauthConsentRoute: typeof OauthConsentRoute
  PlaygroundDiffRoute: typeof PlaygroundDiffRoute
  CreateIndexRoute: typeof CreateIndexRoute
  PlaygroundIndexRoute: typeof PlaygroundIndexRoute
  CNsNameRoute: typeof CNsNameRouteWithChildren
  CNsIndexRoute: typeof CNsIndexRoute
  CNsNameDiffRoute: typeof CNsNameDiffRoute
  CNsNameEditRoute: typeof CNsNameEditRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/browse': {
      id: '/browse'
      path: '/browse'
      fullPath: '/browse'
      preLoaderRoute: typeof BrowseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me': {
      id: '/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof MeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/policy': {
      id: '/policy'
      path: '/policy'
      fullPath: '/policy'
      preLoaderRoute: typeof PolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create/': {
      id: '/create/'
      path: '/create'
      fullPath: '/create/'
      preLoaderRoute: typeof CreateIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create/import': {
      id: '/create/import'
      path: '/create/import'
      fullPath: '/create/import'
      preLoaderRoute: typeof CreateImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guest/verify': {
      id: '/guest/verify'
      path: '/guest/verify'
      fullPath: '/guest/verify'
      preLoaderRoute: typeof GuestVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/playground/': {
      id: '/playground/'
      path: '/playground'
      fullPath: '/playground/'
      preLoaderRoute: typeof PlaygroundIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/playground/diff': {
      id: '/playground/diff'
      path: '/playground/diff'
      fullPath: '/playground/diff'
      preLoaderRoute: typeof PlaygroundDiffRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/$ns/': {
      id: '/c/$ns/'
      path: '/c/$ns'
      fullPath: '/c/$ns/'
      preLoaderRoute: typeof CNsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/$ns/$name': {
      id: '/c/$ns/$name'
      path: '/c/$ns/$name'
      fullPath: '/c/$ns/$name'
      preLoaderRoute: typeof CNsNameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/$ns/$name/': {
      id: '/c/$ns/$name/'
      path: '/'
      fullPath: '/c/$ns/$name/'
      preLoaderRoute: typeof CNsNameIndexRouteImport
      parentRoute: typeof CNsNameRoute
    }
    '/c/$ns/$name/preview': {
      id: '/c/$ns/$name/preview'
      path: '/preview'
      fullPath: '/c/$ns/$name/preview'
      preLoaderRoute: typeof CNsNamePreviewRouteImport
      parentRoute: typeof CNsNameRoute
    }
    '/c/$ns/$name/settings': {
      id: '/c/$ns/$name/settings'
      path: '/settings'
      fullPath: '/c/$ns/$name/settings'
      preLoaderRoute: typeof CNsNameSettingsRouteImport
      parentRoute: typeof CNsNameRoute
    }
    '/c/$ns/$name/versions': {
      id: '/c/$ns/$name/versions'
      path: '/versions'
      fullPath: '/c/$ns/$name/versions'
      preLoaderRoute: typeof CNsNameVersionsRouteImport
      parentRoute: typeof CNsNameRoute
    }
    '/c/$ns/$name_/diff': {
      id: '/c/$ns/$name_/diff'
      path: '/c/$ns/$name/diff'
      fullPath: '/c/$ns/$name/diff'
      preLoaderRoute: typeof CNsNameDiffRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/$ns/$name_/edit': {
      id: '/c/$ns/$name_/edit'
      path: '/c/$ns/$name/edit'
      fullPath: '/c/$ns/$name/edit'
      preLoaderRoute: typeof CNsNameEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/$ns/$name/contributions/': {
      id: '/c/$ns/$name/contributions/'
      path: '/contributions'
      fullPath: '/c/$ns/$name/contributions/'
      preLoaderRoute: typeof CNsNameContributionsIndexRouteImport
      parentRoute: typeof CNsNameRoute
    }
    '/c/$ns/$name/contributions/$number': {
      id: '/c/$ns/$name/contributions/$number'
      path: '/contributions/$number'
      fullPath: '/c/$ns/$name/contributions/$number'
      preLoaderRoute: typeof CNsNameContributionsNumberRouteImport
      parentRoute: typeof CNsNameRoute
    }
    '/c/$ns/$name/contributions/new': {
      id: '/c/$ns/$name/contributions/new'
      path: '/contributions/new'
      fullPath: '/c/$ns/$name/contributions/new'
      preLoaderRoute: typeof CNsNameContributionsNewRouteImport
      parentRoute: typeof CNsNameRoute
    }
  }
}

interface CNsNameRouteChildren {
  CNsNamePreviewRoute: typeof CNsNamePreviewRoute
  CNsNameSettingsRoute: typeof CNsNameSettingsRoute
  CNsNameVersionsRoute: typeof CNsNameVersionsRoute
  CNsNameIndexRoute: typeof CNsNameIndexRoute
  CNsNameContributionsNumberRoute: typeof CNsNameContributionsNumberRoute
  CNsNameContributionsNewRoute: typeof CNsNameContributionsNewRoute
  CNsNameContributionsIndexRoute: typeof CNsNameContributionsIndexRoute
}

const CNsNameRouteChildren: CNsNameRouteChildren = {
  CNsNamePreviewRoute: CNsNamePreviewRoute,
  CNsNameSettingsRoute: CNsNameSettingsRoute,
  CNsNameVersionsRoute: CNsNameVersionsRoute,
  CNsNameIndexRoute: CNsNameIndexRoute,
  CNsNameContributionsNumberRoute: CNsNameContributionsNumberRoute,
  CNsNameContributionsNewRoute: CNsNameContributionsNewRoute,
  CNsNameContributionsIndexRoute: CNsNameContributionsIndexRoute,
}

const CNsNameRouteWithChildren =
  CNsNameRoute._addFileChildren(CNsNameRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BrowseRoute: BrowseRoute,
  MeRoute: MeRoute,
  PolicyRoute: PolicyRoute,
  SettingsRoute: SettingsRoute,
  CreateImportRoute: CreateImportRoute,
  GuestVerifyRoute: GuestVerifyRoute,
  OauthConsentRoute: OauthConsentRoute,
  PlaygroundDiffRoute: PlaygroundDiffRoute,
  CreateIndexRoute: CreateIndexRoute,
  PlaygroundIndexRoute: PlaygroundIndexRoute,
  CNsNameRoute: CNsNameRouteWithChildren,
  CNsIndexRoute: CNsIndexRoute,
  CNsNameDiffRoute: CNsNameDiffRoute,
  CNsNameEditRoute: CNsNameEditRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
